<template>
  <div class="container-story disp-scroll">
    <!-- 画像選択用のモーダル -->
    <ModalSelectMedia @updated="selectImage"></ModalSelectMedia>
    <!-- リンクコピー用 -->
    <input type="hidden" style="opacity: 0 !important;" id="copy-code" :value="copyURL"/>
    <!-- 一覧に戻る時のモーダル -->
    <b-modal width="500px" :active.sync="isSaveBackModal">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title title" style="font-size: 24px;">
            一覧に戻る
          </p>
        </header>
        <div class="card-content">
          <h2 style="font-size: larger; margin-bottom: 16px;">セーブして一覧に戻りますか？</h2>
          <div style="display: flex; justify-content: space-around; align-items: center; flex-wrap: wrap;">
            <button style="width: 220px;" class="button is-primary" @click="saveBack()">セーブして一覧に戻る</button>
            <button style="width: 220px;" class="button" @click="notSaveBack()">セーブしないで一覧に戻る</button>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- キャラクターの画像を変更 -->
    <b-modal width="500px" :active.sync="isChangeCharacterImageModal">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title title" style="font-size: 24px;">
            キャラクターの画像を選択してください。
          </p>
        </header>
        <div class="card-content" style="padding: 16px;">
          <div class="img-box">
            <div v-for="i in 9" :key="i">
              <img @click="changeCharacterIcon(0, i)" class="character-icon" :src="getIconCharacter(0, i, null)"/>
              <img @click="changeCharacterIcon(1, i)" class="character-icon" :src="getIconCharacter(1, i, null)"/>
            </div>
            <b-upload v-model="tempOriginalIconFile" accept="image/*">
              <div class="character-icon chara-plus-button">＋</div>
            </b-upload>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- キャラクターの変更モーダル -->
    <b-modal width="500px" :active.sync="isChangeCharacterDialogModal">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title title" style="font-size: 24px;">
            キャラクターの変更
          </p>
        </header>
        <div class="card-content">
          <h2 style="font-size: larger;">どのキャラクターに変更しますか？</h2>
          <div style="display: flex; justify-content: center; align-items: center; padding: 8px; width: 100%;">
            <b-select style="max-width: 250px;" v-model="selectedCharacter" v-if="changeTempCharacterDialog">
              <option :value="null" v-if="changeTempCharacterDialog.status == 2">設定なし</option>
              <option v-for="(c, i) in characters" :key="i" :value="c">{{c.name}}</option>
            </b-select>
          </div>
          <hr>
          <div style="display: flex; justify-content: space-around; align-items: center; flex-wrap: wrap;">
            <button style="width: 220px;" class="button is-primary" @click="changeCharacterDialog()">変更</button>
            <button style="width: 220px;" class="button" @click="isChangeCharacterDialogModal=false">キャンセル</button>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- キャラクターの変更モーダル（temp） -->
    <b-modal width="500px" :active.sync="isChangeCharacterTempDialogModal">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title title" style="font-size: 24px;">
            キャラクターの変更
          </p>
        </header>
        <div class="card-content">
          <h2 style="font-size: larger;">どのキャラクターに変更しますか？</h2>
          <div style="display: flex; justify-content: center; align-items: center; padding: 8px; width: 100%;" v-if="tempDialog">
            <b-select style="max-width: 250px;" v-model="selectedCharacter">
              <option :value="null" v-if="tempDialog.status == 2">設定なし</option>
              <option v-for="(c, i) in characters" :key="i" :value="c">{{c.name}}</option>
            </b-select>
          </div>
          <hr>
          <div style="display: flex; justify-content: space-around; align-items: center; flex-wrap: wrap;">
            <button style="width: 220px;" class="button is-primary" @click="changeCharacterTempDialog()">変更</button>
            <button style="width: 220px;" class="button" @click="isChangeCharacterTempDialogModal=false">キャンセル</button>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- キャラクターの削除をしても良いか聞くモーダル -->
    <b-modal width="500px" :active.sync="isDeleteCharacterModal">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title title" style="font-size: 24px;">
            キャラクターの削除
          </p>
        </header>
        <div class="card-content">
          <h2 style="font-size: larger;">キャラクターを削除してもよろしいですか？</h2>
          <p style="font-size: medium; color: #666; margin-bottom: 16px;">※本キャラクターの会話も削除されます。</p>
          <p style="font-size: medium; color: #666; margin-bottom: 16px;">※削除後に再読み込みが発生いたします。</p>
          <div style="display: flex; justify-content: space-around; align-items: center; flex-wrap: wrap;">
            <button style="width: 220px;" class="button is-primary" @click="deleteCharacter()">削除</button>
            <button style="width: 220px;" class="button" @click="isDeleteCharacterModal=false">キャンセル</button>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- シーンの削除をしても良いか聞くモーダル -->
    <b-modal width="500px" :active.sync="isDeleteSceneModal">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title title" style="font-size: 24px;">
            シーンの削除
          </p>
        </header>
        <div class="card-content">
          <h2 style="font-size: larger;">シーンを削除してもよろしいですか？</h2>
          <p style="font-size: medium; color: #666; margin-bottom: 16px;">※本キャラクターの会話も削除されます。</p>
          <div style="display: flex; justify-content: space-around; align-items: center; flex-wrap: wrap;">
            <button style="width: 220px;" class="button is-primary" @click="deleteScene()">削除</button>
            <button style="width: 220px;" class="button" @click="isDeleteSceneModal=false">キャンセル</button>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- slide scene -->
    <transition name="right">
      <div class="scene-list disp-scroll" v-if="isSceneList">
        <p>シーン一覧</p>
        <draggable id="scenes-list" :list="scenes" @end="saveSceneOrder(scenes)" :options="{animation: 300, group: { name: 'SCENES', pull: 'clone', put: false}, handle: '.drag'}">
          <div class="scene-box" :class="{'now-scene': nowScene == si}" v-for="(s, si) in scenes" :key="si">
            <img :src="getBackgroundScene(s)"/>
            <div class="scene-inner">
              <button class="button is-small drag">
                <span class="mdi mdi-drag-vertical mdi-24px"></span>
              </button>
              <p @click="nowScene=si;isSceneList=false">シーン {{s.scene_order}}</p>
              <button @click="idxChangeSceneImage=si;noticeImageOriginal=true;noticeImageDefault=true;" class="button is-small change">
                背景<br>変更
              </button>
              <button @click="isDeleteSceneModal=true;deleteTempScene=s" class="button is-small del" :disabled="scenes.length <= 1">
                シーン<br>削除
              </button>
            </div>
            <transition name="bottom">
              <div class="change-image-box" v-if="idxChangeSceneImage == si">
                <template v-if="!isImageLoading">
                  <b-upload accept="image/*" v-model="uploadedFile" @input="loadFile">
                    <div class="button is-primary is-small" style="margin-left: 24px;">
                      <template v-if="!isImageSaving"><b-icon icon="upload"></b-icon><span>新しく画像を追加する</span></template>
                      <template v-if="isImageSaving"><span><span class="mdi mdi-loading mdi-spin" style="margin-right: 4px;"></span>セーブ中です</span></template>
                    </div>
                  </b-upload>
                </template>
                <button class="button" @click="idxChangeSceneImage=-1"><span class="mdi mdi-close-box-outline mdi-24px"></span></button>
                <div class="scroll-parent">
                  <div class="change-image-galary absolute original disp-scroll" v-if="tagImages.length > 0" @scroll="onScrollImg('original')">
                    <img :id="'image-' + idx" v-for="(img, idx) in tagImages" :key="idx" :src="img.image_data" @click="changeSceneImageOrg(img.pk)"/>
                  </div>
                  <div class="scroll-box" v-if="noticeImageOriginal && tagImages.length > 3 && !isImageSaving"><p class="move"><span class="mdi mdi-gesture-swipe-horizontal mdi-48px"></span></p><span>スクロールできます</span></div>
                  <div class="loading-cover" v-if="isImageSaving"><i class="loading mdi mdi-loading mdi-spin mdi-48px"></i></div>
                </div>
                <div class="scroll-parent">
                  <div class="change-image-galary absolute disp-scroll" @scroll="onScrollImg('default')">
                    <img v-for="i in 49" :key="i" :src="getBackgroundImage(i)" @click="changeSceneImage(i)"/>
                  </div>
                  <div class="scroll-box" v-if="noticeImageDefault"><p class="move"><span class="mdi mdi-gesture-swipe-horizontal mdi-48px"></span></p><span>スクロールできます</span></div>
                </div>
              </div>
            </transition>
          </div>
        </draggable>
        <button class="button" @click="createScene(scenes.length + 1)">シーンを追加する</button>
      </div>
    </transition>
    <!-- slide title -->
    <transition name="right">
      <div class="scene-list" v-if="isSettingModal">
        <p>求人ノベル設定</p>
        <div class="dot-line"></div>
        <p style="font-size: smaller; text-align: left; font-weight: 600; margin-left: 8px;">タイトルプレビュー</p>
        <div class="header-recruit">
          <img class="title-image" :src="getBackgroundStory(story)" v-if="story"/>
          <div class="title-box" v-if="story">
            <p>{{story.title}}</p>
            <p style="font-size: smaller; font-weight: 500;">{{user.companyName}}</p>
          </div>
        </div>
        <div class="dot-line"></div>
        <div class="scene-box">
          <div class="setting-box">
            <div class="setting-box-left">
              <p style="font-weight: 600;">公開設定</p>
              <p style="font-size: is-small; color:#555;">公開にすることで、HRモンスター求人ページにも掲載されます。</p>
            </div>
            <div class="setting-box-right">
              <button @click="updateStoryPublic(!story.is_public)" class="button is-small is-fullwidth">{{story.is_public ? '非公開' : '公開'}}</button>
            </div>
          </div>
          <div class="dot-line"></div>
          <div class="setting-box">
            <div class="setting-box-left">
              <p style="font-weight: 600;">求人ノベルのタイトル画像</p>
              <p style="font-size: is-small; color:#555;">求人ノベルのタイトル画像を設定できます。</p>
            </div>
            <div class="setting-box-right">
              <button class="button is-small is-fullwidth" @click="isChangeStoryImage=true">設定する</button>
            </div>
          </div>
          <transition name="bottom">
            <div class="change-image-box" style="margin-botton: 4px;" v-if="isChangeStoryImage">
              <template v-if="!isImageLoading">
                <b-upload accept="image/*" v-model="uploadedFile" @input="loadFile">
                  <div class="button is-primary is-small">
                    <template v-if="!isImageSaving"><b-icon icon="upload"></b-icon><span>新しく画像を追加する</span></template>
                    <template v-if="isImageSaving"><span><span class="mdi mdi-loading mdi-spin" style="margin-right: 4px;"></span>セーブ中です</span></template>
                  </div>
                </b-upload>
              </template>
              <button class="button" @click="isChangeStoryImage=false"><span class="mdi mdi-close-box-outline"></span></button>
              <div class="change-image-galary disp-scroll" v-if="tagImages.length > 0">
                <img v-for="(img, idx) in tagImages" :key="idx" :src="img.image_data" @click="changeStoryImageOrg(img.pk)"/>
              </div>
              <div class="change-image-galary disp-scroll">
                <img v-for="i in 49" :key="i" :src="getBackgroundImage(i)" @click="changeStoryImage(i)"/>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </transition>
    <!-- モーダル背景 -->
    <div class="scene-list-modal" @click="isSceneList=false;isSettingModal=false" v-if="isSceneList||isSettingModal"></div>
    <!-- ヘッダー大元 -->
    <div class="header-box">
      <div class="header-menu">
        <p><b style="font-size:28px; font-weight: 800;">Story</b></p>
        <p style="margin-left: 25px; font-size:16px; color: #666; margin-top: 8px;">求人ノベル作成画面</p>
        <p style="margin-left: 25px; font-size:16px; color: #666; margin-top: 8px;" v-if="!isSavingStory"><span style="color: green;" class="mdi mdi-check-circle-outline"></span> セーブが完了し、現在最新の状態です</p>
        <p style="margin-left: 25px; font-size:16px; color: #666; margin-top: 8px;" v-if="isSavingStory"><span class="mdi mdi-loading mdi-spin"></span> セーブ中です</p>
      </div>
      <!-- <button @click="isSaveBackModal=true" class="button is-primary">一覧に戻る</button> -->
      <button @click="saveBack()" class="button is-primary">一覧に戻る</button>
    </div>
    <div class="main-container">
      <div class="loading-container" v-if="isStoryLoading">
        <span class="mdi mdi-loading mdi-spin mdi-48px"></span>
      </div>
      <!-- ヘッダー：タイトルの編集周り -->
      <div class="header-main" v-if="story">
        <p>タイトル：
          <span>
            <input class="input is-small" v-model="story.title" @change="changeStoryTitle(story)" maxlength="100" v-if="story"/>
            <p>設定した文字数が多い場合、表示時に省略される場合があります。</p>
          </span>
        </p>
        <div>
          <b-tooltip label="タグ">
            <button @click="openTagModal" class="button is-small noborder-button"><span class="mdi mdi-tag" style="margin-right: 4px"></span></button>
          </b-tooltip>
          <b-tooltip label="公開リンク"> 
            <button class="button is-small noborder-button" @click="copyLink()"><span class="mdi mdi-link-variant"></span></button>
          </b-tooltip>
          <b-tooltip label="プレビュー">
            <a class="button is-small noborder-button" :href="'/recruits/story/' + story.company_id + '/' + story.story_id" target="_blank" rel="noopener"><span class="mdi mdi-play"></span></a>
          </b-tooltip>
          <b-tooltip label="設定">
            <button class="button is-small noborder-button" @click="isSettingModal=true"><span class="mdi mdi-settings"></span></button>
          </b-tooltip>
        </div>
      </div>
      <div class="menu-box">
        <button class="button is-small button-story" @click="createCharacter()">登場人物を追加</button>
        <b-upload v-model="tempImportFile" accept="text/plain">
          <a class="button is-small button-story">
            会話のインポート
          </a>
        </b-upload>
        <!-- 左：キャラクターの編集 -->
        <div class="character-container disp-scroll" v-if="characters.length > 0">
          <div class="character-box" v-for="(c, ci) in characters" :key="ci">
            <button class="button close-button" @click="deleteTempCharacter=c;isDeleteCharacterModal=true">
              <span class="mdi mdi-close-circle-outline mdi-24px"></span>
            </button>
            <button class="button chat-button" @click="createDialog(c)">
              <span class="mdi mdi-comment-outline mdi-24px"></span>
            </button>
            <Tooltip message="ドラッグ＆ドロップで会話を追加">
              <draggable @end="dropCharacter(c)">
                <img @drag="draggingCharacter" @click="isChangeCharacterImageModal=true;changeTempCharacter=c" class="character-icon" style="margin: 0;" :src="getIconCharacter(c.sex_type, c.icon_type, c.character_icon)"/>
              </draggable>
            </Tooltip>
            <input class="input is-small" @change="updateCharacter(c)" v-model="c.name"/>
          </div>
          <div style="width: 100px; height: 100px; margin: 8px;" v-if="characters.length%2!=0"></div>
        </div>
      </div>
      <!-- 右：会話などの編集 -->
      <div class="edit-box">
        <div class="menu-edit">
          <div style="display: flex; align-items: center;" v-if="scenes.length > 0">
            <button class="button is-small button-story" style="margin-right: 16px;" @click="isSceneList=true" v-if="scenes.length > 0">
              <span class="mdi mdi-animation-outline" style="margin-right: 4px;"></span> シーン設定
            </button>
            <b-select class="button-story" placeholder="シーンを選択" size="is-small" v-model="nowScene" rounded>
              <option v-for="(sc, sci) in scenes" :value="sci" :key="sci">
                シーン {{sc.scene_order}} 
              </option>
            </b-select>
          </div>
          <div style="display: flex; align-items: center;" v-if="scenes.length > 0">
            <b-select placeholder="主人公を選択" size="is-small" style="max-width: 200px;" @input="$store.dispatch('chatbot/updateScene', scenes[nowScene])" v-model="scenes[nowScene].main_character" rounded>
              <option v-for="(c, ci) in characters" :value="c.pk" :key="ci">
                主人公：{{c.name}}
              </option>
            </b-select>
            <p v-if="isInsertMode==false" class="add-btn-explaination">追加ボタン<br><span class="str">非表示</span></p>
            <p v-if="isInsertMode" class="add-btn-explaination">追加ボタン<br><span class="str">表示</span></p>
            <b-switch v-model="isInsertMode" size="is-small"></b-switch>
          </div>
        </div>
        <div class="scene-container" v-if="scenes.length > 0">
          <img class="background-scene" :src="getBackgroundScene(scenes[nowScene])"/>
          <div class="balloon-list disp-scroll" ref="storyArea">
            <!-- 1番上の吹き出し追加ボタン -->
            <div class="temp-add-box" v-if="(idxCreateDialog != -1 && storyDialog.length < 1) || (idxCreateDialog != -1 && isInsertMode)">
              <button class="button is-fullwidth" @click="createTempDialog(-1)"><span class="mdi mdi-plus"></span></button>
            </div>
            <div class="temp-add-box" v-if="idxCreateDialog == -1">
              <button class="button is-fullwidth" @click="idxCreateDialog=-2"><span class="mdi mdi-minus"></span></button>
            </div>
            <div class="temp-add-openbox" v-if="idxCreateDialog == -1">
              <div class="message-box preview-box">
                <!-- アイコン -->
                <div @click="isChangeCharacterTempDialogModal=true" class="temp-img-box" v-if="tempDialog.status == 0 || (tempDialog.status == 2 && tempDialog.character) || tempDialog.status == 3">
                  <img :src="getIconCharacterFromDialog(tempDialog.character)" v-if="tempDialog.character"/>
                  <div style="font-size: small;" v-if="!tempDialog.character">
                    設定<br>なし
                  </div>
                  <p>{{getCharacterName(tempDialog.character)}}</p>
                </div>
                <div class="parts-box">
                  <div class="parts" v-for="(p, pi) in parts" :key="pi" @click="changeTempParts(p)">
                    <p><span :class="'mdi mdi-24px ' + p.icon"></span></p>
                    <p>{{p.name}}</p>
                  </div>
                </div>
              </div>
            </div>
            <draggable id="balloon-list" :list="storyDialog" @end="saveDialogOrder(storyDialog)" :options="{animation: 300, group: { name: 'DIALOG', pull: 'clone', put: false}, handle: '.drag-button'}" v-if="storyDialog.length > 0">
              <div class="dialog-box" @mouseover="idxOverDialog=di" @mouseleave="idxOverDialog=-1;idxEditDialog=-1" v-for="(d, di) in storyDialog" :key="di">
                <button class="button close-button" :class="{'left-button': (d.character && d.character == scenes[nowScene].main_character)}" @click="$store.dispatch('chatbot/deleteDialog', d.pk)" v-if="idxOverDialog == di">
                  <span class="mdi mdi-close-circle-outline mdi-24px"></span>
                </button>
                <button class="button drag-button"   :class="{'left-button': (d.character && d.character == scenes[nowScene].main_character)}" v-if="idxOverDialog == di">
                  <span class="mdi mdi-drag-vertical mdi-24px"></span>
                </button>
                <button class="button app-button"   :class="{'left-button': (d.character && d.character == scenes[nowScene].main_character)}" @click="idxChangePartsDialog = di" v-if="idxOverDialog == di && idxChangePartsDialog != di">
                  <span class="mdi mdi-apps mdi-24px"></span>
                </button>
                <button class="button app-button"   :class="{'left-button': (d.character && d.character == scenes[nowScene].main_character)}" @click="idxChangePartsDialog = -1" v-if="idxOverDialog == di && idxChangePartsDialog == di">
                  <span class="mdi mdi-minus mdi-24px"></span>
                </button>
                <!-- Status: 0 会話 -->
                <div class="bln-box" :class="{'my-speaker': d.character == scenes[nowScene].main_character}" v-if="d.status == 0">
                  <img @click="isChangeCharacterDialogModal=true;changeTempCharacterDialog=d" :src="getIconCharacterFromDialog(d.character)"/>
                  <div class="message-box">
                    <p>{{getCharacterName(d.character)}}</p>
                    <textarea :id="'textarea-bln' + di" placeholder="テキストを入力" @blur="$store.dispatch('chatbot/updateDialog', d)" @focus="readColumn('bln', di)" @input="readColumn('bln', di)" rows="1" v-model="d.content"></textarea>
                  </div>
                </div>
                <!-- Status: 1 タイトル -->
                <div class="bln-box -title" v-if="d.status == 1">
                  <div class="message-box-title">
                    <textarea 
                      :id="'textarea-title' + di" placeholder="テキストを入力"
                      @blur="$store.dispatch('chatbot/updateDialog', d)"
                      @focus="readColumn('title', di)" @input="readColumn('title', di)"
                      @click="idxEditDialog=di"
                      rows="1"
                      v-model="d.content"
                      :class="[
                        {'font-color-black': d.title_color == 'black'},
                        {'font-color-white': d.title_color == 'white'},
                        {'font-color-red': d.title_color == 'red'},
                        {'font-color-orange': d.title_color == 'orange'},
                        {'font-color-yellow': d.title_color == 'yellow'},
                        {'font-color-green': d.title_color == 'green'},
                        {'font-color-skyblue': d.title_color == 'skyblue'},
                        {'font-color-blue': d.title_color == 'blue'},
                        {'font-color-purple': d.title_color == 'purple'},
                        {'bg-color-black': d.title_bg_color == 'black'},
                        {'bg-color-white': d.title_bg_color == 'white'},
                        {'bg-color-red': d.title_bg_color == 'red'},
                        {'bg-color-orange': d.title_bg_color == 'orange'},
                        {'bg-color-yellow': d.title_bg_color == 'yellow'},
                        {'bg-color-green': d.title_bg_color == 'green'},
                        {'bg-color-skyblue': d.title_bg_color == 'skyblue'},
                        {'bg-color-blue': d.title_bg_color == 'blue'},
                        {'bg-color-purple': d.title_bg_color == 'purple'},
                        {'font-small': d.title_size == '小'},
                        {'font-medium': d.title_size == '中'},
                        {'font-large': d.title_size == '大'},
                      ]">
                    </textarea>
                  </div>
                  <div class="title-edit-container" v-if="idxEditDialog == di">
                    <div class="title-edit-wrapper">
                      <div class="color-btn-container">
                        <p>文字色</p>
                        <div class="color-btn-wrapper">
                          <div v-for="(c, i) in titleColor" :key="i" @click="clickColorBtn(d, c)" class="color-btn" :style="{backgroundColor: c}"></div>
                        </div>
                        <p class="margin-top8">背景色</p>
                        <div class="color-btn-wrapper">
                          <div v-for="(c, i) in titleColor" :key="i" @click="clickBgColorBtn(d, c)" class="color-btn" :style="{backgroundColor: c}"></div>
                        </div>
                        <p class="margin-top8">文字の大きさ</p>
                        <div class="size-btn-wrapper">
                          <div v-for="(s, i) in titleSize" :key="i" @click="clickSizeBtn(d, s)" ><button class="button is-small">{{s}}</button></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Status: 2 画像 -->
                <div class="bln-box" :class="{'my-speaker': d.character == scenes[nowScene].main_character, 'no-character': !d.character}" v-if="d.status == 2">
                  <img @click="isChangeCharacterDialogModal=true;changeTempCharacterDialog=d" :src="getIconCharacterFromDialog(d.character)" v-if="d.character"/>
                  <div @click="idxChangeDialogImage=di" class="message-box">
                    <p v-if="d.character">{{getCharacterName(d.character)}}</p>
                    <img :src="d.store_image" v-if="d.store_image" @click="idxEditDialog=di">
                    <img :src="d.image" v-else-if="d.image" @click="idxEditDialog=di">
                    <div class="no-image" v-else>
                      <p @click="idxEditDialog=di">
                      画像が設定されていません。
                      </p>
                    </div>
                    <div class="upload-button" v-if="idxEditDialog == di">
                      <div @click="openSelectModal('image')" v-if="!isSavingStory && $isClient()">
                        <a class="button is-small" style="margin-top: 8px;">
                          <span class="mdi mdi-image" style="margin-right: 8px;"></span>画像
                        </a>
                      </div>
                      <div v-if="!isSavingStory && $isUser()">
                        <b-upload accept="image/*" v-model="uploadedImage" @input="loadFile">
                          <a @click="dialog=d" class="button is-small" style="margin-top: 8px;">
                            <span class="mdi mdi-image" style="margin-right: 8px;"></span>画像
                          </a>
                        </b-upload>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Status: 3 電話 -->
                <div class="bln-box" :class="{'my-speaker': d.character == scenes[nowScene].main_character}" v-if="d.status == 3">
                  <img @click="isChangeCharacterDialogModal=true;changeTempCharacterDialog=d" :src="getIconCharacterFromDialog(d.character)"/>
                  <div class="message-box">
                    <p>{{getCharacterName(d.character)}}</p>
                    <div class="phone-box">
                      <p @click="idxEditDialog=di"><span :class="phoneImage[d.phone_type]"></span></p>
                      <p @click="idxEditDialog=di">{{phoneTypes[d.phone_type]}}</p>
                    </div>
                    <b-select placeholder="選択" size="is-small" @input="$store.dispatch('chatbot/updateDialog', d)" v-model="d.phone_type" rounded v-if="idxEditDialog == di">
                      <option v-for="(ph, phi) in phoneTypes" :value="phi" :key="phi">
                        {{ph}}
                      </option>
                    </b-select>
                  </div>
                </div>
                <!-- Status: 4 次の話へ -->
                <div class="bln-box" v-if="d.status == 4">
                  <div class="next-box">
                    <p style="color: #f8f8f8;">次の求人ノベルへ</p>
                    <b-select size="is-small" class="select-box" style="align: left;" placeholder="次の求人ノベルを入力" @blur="$store.dispatch('chatbot/updateDialog', d)" v-model="d.content">
                      <option v-for="(st, sti) in stories" :key="sti" :value="st.story_id">{{st.title}}</option>
                    </b-select>
                  </div>
                </div>
                <!-- Status: 5 動画 -->
                <div class="bln-box" :class="{'my-speaker': d.character == scenes[nowScene].main_character, 'no-character': !d.character}" v-if="d.status == 5">
                  <img @click="isChangeCharacterDialogModal=true;changeTempCharacterDialog=d" :src="getIconCharacterFromDialog(d.character)" v-if="d.character"/>
                  <div @click="idxChangeDialogImage=di" class="message-box">
                    <p v-if="d.character">{{getCharacterName(d.character)}}</p>
                    <!-- 動画が設定されているとき。 -->
                    <div class="movie-container">
                      <iframe @mouseover="idxEditDialog=di" v-if="d.movie_url&&d.movie_url!=''" width="240" height="135" :src="d.movie_url" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                      <video @mouseover="idxEditDialog=di" v-else-if="d.store_movie&&$isClient()" :src="d.store_movie" width="240" height="135" controls>
                        <p>動画を再生するにはサポートされたブラウザが必要です。</p>
                      </video>
                      <video @mouseover="idxEditDialog=di" v-else-if="d.movie&&$isUser()" :src="d.movie" width="240" height="135" controls>
                        <p>動画を再生するにはサポートされたブラウザが必要です。</p>
                      </video>
                      <div v-else class="no-image" width="240" height="135"><p @click="idxEditDialog=di">動画が設定されていません。</p></div>
                    </div>
                    <!-- 動画が設定されていないとき -->
                    <div class="no-movie" v-if="idxEditDialog == di || isSelecting">
                      <p class="no-movie-item">動画のURLを入力</p>
                      <b-field grouped>
                        <b-radio v-model="movieParameter.use" native-value="youtube" size="is-small"></b-radio>
                        <b-input :disabled="movieParameter.use!='youtube'" placeholder="URLを入力" v-model="movieParameter.url" max-length="100" size="is-small" expanded></b-input>
                      </b-field>
                      <p class="no-movie-item">動画をアップロード</p>
                      <b-field class="file" grouped>
                        <b-radio v-model="movieParameter.use" native-value="movie_file" size="is-small"></b-radio>
                        <div @click="openSelectModal('video')" v-if="!isSavingStory && $isClient()">
                          <a class="button is-small" @click="isSelecting=true">
                            <b-icon icon="upload"></b-icon>
                            <span>アップロード</span>
                          </a>
                        </div>
                        <div v-if="!isSavingStory && $isUser()">
                          <b-upload accept="video/*" v-model="uploadedMovie" @input="loadFile">
                            <a class="button is-small">
                              <span class="mdi mdi-upload"></span>アップロード
                            </a>
                          </b-upload>
                        </div>
                      </b-field>
                      <p v-if="movieParameter.filename!=''" style="font-size: 12px;">{{movieParameter.filename}}</p>
                      <div class="buttons" style="margin-top: 24px;">
                          <b-button @click="registerMovie(d);isSelecting=false" type="is-primary" size="is-small" expanded>変更</b-button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Status: 6　プッシュ通知 -->
                <div class="bln-box -title" v-if="d.status == 6">
                  <div class="news-container">
                    <div class="news-img">
                      <img @click="idxEditDialog=di" :src="getIconNews(d.news_icon)">
                    </div>
                    <div class="news-title">
                      <textarea
                        :id="'textarea-news-title' + di" placeholder="通知タイトルを入力(25字以下)"
                        class="news-title"
                        @blur="$store.dispatch('chatbot/updateDialog', d)"
                        @click="idxEditDialog=di"
                        v-model="d.content"
                        maxlength="25"></textarea>
                    </div>
                    <div class="news-text">
                      <textarea
                        :id="'textarea-news-text' + di" placeholder="テキストを入力(50字以下)"
                        class="news-text"
                        @blur="$store.dispatch('chatbot/updateDialog', d)"
                        @click="idxEditDialog=di"
                        v-model="d.news_content"
                        maxlength="50"></textarea>
                    </div>
                  </div>
                  <div class="news-edit-container" v-if="idxEditDialog == di">
                    <div class="news-item">
                      <p>アイコンを選択</p>
                      <div class="news-edit-wrapper">
                        <div v-for="(i, index) in 7" :key="index">
                          <img @click="d.news_icon=i; $store.dispatch('chatbot/updateDialog', d)" :src="getIconNews(i)">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Status: 7　クイズ -->
                <div class="bln-box" v-if="d.status == 7">
                  <div class="message-box">
                    <textarea :id="'textarea-quiz' + di" class="quiz-question"
                      placeholder="問題文を入力" @blur="$store.dispatch('chatbot/updateDialog', d)" @focus="readColumn('quiz', di)" @input="readColumn('quiz', di)"
                      rows="1" v-model="d.content"></textarea>
                    <template v-if="d.quiz_choices">
                      <div v-for="(c, ci) in d.quiz_choices" :key="ci" class="quiz-choices">
                        <p>{{ci==0 ? '正解答' : '不正解答'}}</p>
                        <input type="text" v-model="d.quiz_choices[ci]" @blur="$store.dispatch('chatbot/updateDialog', d)">
                      </div>
                      <div class="quiz-add-choice" v-if="idxOverDialog == di">
                        <button class="button" @click="clickChoiceBtn(d, 'plus')" :disabled="d.quiz_choices.length >= 5"><span class="mdi mdi-plus"></span></button>
                        <button class="button" @click="clickChoiceBtn(d, 'minus')" :disabled="d.quiz_choices.length <= 2"><span class="mdi mdi-minus"></span></button>
                      </div>
                    </template>
                    <template v-else>
                      <div class="quiz-add-choice" v-if="idxOverDialog == di">
                        <button class="button is-fullwidth" @click="clickChoiceBtn(d, 'plus')"><span class="mdi mdi-plus"></span></button>
                      </div>
                    </template>
                  </div>
                </div>
                <!-- 設定メニュー -->
                <div v-if="idxChangePartsDialog == di">
                  <div class="parts-box">
                    <div class="parts" v-for="(p, pi) in parts" :key="pi" @click="changeParts(d, p)">
                      <div v-if="p.status!=2">
                        <p><span :class="'mdi mdi-24px ' + p.icon"></span></p>
                        <p>{{p.name}}</p>
                      </div>
                      <div v-if="p.status==2" @click="idxChangeDialogImage=di">
                        <div>
                          <p><span :class="'mdi mdi-24px ' + p.icon"></span></p>
                          <p>{{p.name}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 会話の追加 -->
                <div class="temp-add-box" v-if="idxCreateDialog != di && isInsertMode">
                  <button class="button is-fullwidth" @click="createTempDialog(di)"><span class="mdi mdi-plus"></span></button>
                </div>
                <div class="temp-add-box" v-if="idxCreateDialog == di">
                  <button class="button is-fullwidth" @click="idxCreateDialog=-2"><span class="mdi mdi-minus"></span></button>
                </div>
                <div class="temp-add-openbox" v-if="idxCreateDialog == di">
                  <div class="message-box preview-box">
                    <!-- アイコン -->
                    <div @click="isChangeCharacterTempDialogModal=true" class="temp-img-box" v-if="tempDialog.status == 0 || (tempDialog.status == 2 && tempDialog.character) || tempDialog.status == 3">
                      <img :src="getIconCharacterFromDialog(tempDialog.character)" v-if="tempDialog.character"/>
                      <div style="font-size: small;" v-if="!tempDialog.character">
                        設定<br>なし
                      </div>
                      <p>{{getCharacterName(tempDialog.character)}}</p>
                    </div>
                    <div class="parts-box"> 
                      <div class="parts" v-for="(p, pi) in parts" :key="pi" @click="changeTempParts(p)">
                        <p><span :class="'mdi mdi-24px ' + p.icon"></span></p>
                        <p>{{p.name}}</p>
                      </div> 
                    </div>
                  </div>
                </div>
              </div>
            </draggable>
          </div>
        </div>
      </div>
    </div>
    <b-modal width="500px" :active.sync="tagModalFlg">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title title" style="font-size: 20px;">
            タグの設定
          </p>
        </header>
        <div class="card-content">
          <div class="taglist">
            <template v-if="story && story.tags">
              <div class="tag is-primary is-small" style="margin-right: 5px; margin-bottom: 5px;" v-for="(t, i) in story.tags.split(',')" :key="i" v-show="t != ''">
                {{t}}
                <span class="mdi mdi-close delete-tag-btn" style="margin-left:5px;" @click="deleteTags(story, i)"></span>
              </div>
            </template>
            <div class="tag is-primary is-small" style="margin-bottom: 5px;">
              <inputTag :child="story" ref="refinput"/>
              <button class="plus-button mdi mdi-plus mdi-24px" @click="$refs.refinput.updateTags()"></button>
            </div>
          </div>
          <div v-show="isClickTag && isClickId==story.story_id">
            <button class="tag is-small buttonCandidate"  v-for="(t, i) in searchWordsBox" :key="i"  @click="tagCandidate(story, t[0])">
              {{t[0]}}
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import draggable from 'vuedraggable'
import nameList from '@/assets/json/character/name'
import ModalSelectMedia from '@/components/ui/ModalSelectMedia'
import Tooltip from '@/components/atoms/tooltips/Tooltip'
export default {
  name: 'StoryEdit',
  componentName: 'StoryEdit',
  components: {
    draggable,
    ModalSelectMedia,
    Tooltip,
    inputTag: {
      template: `<input class="edit-taginput" placeholder="タグを設定" v-model="tag" ref="tag" @focus="isClick(true)"/>`,
      props: ['child'],
      data () {
        return {
          tag: '',
          tagList:[
            ["採用", "さいよう", "saiyou"],
            ["求人", "きゅうじん", "kyuujinn"],
            ["ロールプレイ", "ろーるぷれい", "role play"],
            ["インタビュー", "いんたびゅー", "interview"],
            ["その他", "そのた", "sonota"],
          ],
        }
      },
      mounted(){
        this.$nextTick(() => {
          const $input = this.$refs.tag;
          $input.addEventListener("keyup", this.update);
          $input.addEventListener("compositionend", this.update);
        });
      },
      methods: {
        isClick(flg){
          this.$store.dispatch('chatbot/isClickTag', {flg:flg, id:this.child.story_id, tagList:this.tagList})
        },
        tagBlank(){
          this.tag=''
        },
        update (e) {
          this.tag = e.target.value;
          this.$store.dispatch('chatbot/searchWordsInitial', {tag: this.tag, tagList: this.tagList})
        },
        updateTags (index) {
          if (this.tag == '') alert('文字を入力してください。')
          var tagBox = []
          if (this.child.tags) {
            tagBox.push(this.child.tags.split(","))
            if (tagBox[0].indexOf(this.tag) == -1) {
              let updateChild = this.child
              if (updateChild.tags) {
                updateChild.tags += this.tag + ','
              } else {
                updateChild.tags = this.tag + ','
              } 
              this.$store.dispatch('chatbot/updateStory', updateChild)
            }
          }
          else {
            let updateChild = this.child
            updateChild.tags = this.tag + ','
            this.$store.dispatch('chatbot/updateStory', updateChild)
          }
          this.tag = ''
        }
      }
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('chatbot', ['stories', 'story', 'scenes', 'storyDialog', 'characters', 'isStoryLoading', 'isSavingStory', 'createDialogFlg', 'isDelete', 'searchWordsBox', 'isClickTag', 'isClickId', 'isClick']),
    ...mapState('mediapool', ['orgImages', 'tagImages', 'selectModalTarget', 'isImageLoading', 'isImageSaving', 'newImage'])
  },
  data () {
    return {
      isSceneList: false,
      isSaveBackModal: false,
      isChangeCharacterImageModal: false,
      isDeleteCharacterModal: false,
      isDeleteSceneModal: false,
      isSettingModal: false,
      isMakeDialog: false,
      isChangeCharacterDialogModal: false,
      isChangeCharacterTempDialogModal: false,
      isChangeStoryImage: false,
      isInsertMode: false,
      isSelecting: false,
      idxChangeSceneImage: -1,
      idxOverDialog: -1,
      idxChangePartsDialog: -1,
      idxChangeDialogImage: -1,
      idxCreateDialog: -2,
      idxEditDialog: -2,
      changeTempCharacter: null,
      changeTempCharacterDialog: null,
      deleteTempCharacter: null,
      deleteTempScene: null,
      tempFile: null,
      tempOriginalIconFile: null,
      tempImportFile: null,
      tempDialog: null,
      selectedCharacter: null,
      nowScene: 0,
      tempScene: 0,
      initDialog: true,
      uploadedFile: null,
      uploadedImage: null,
      uploadedMovie: null,
      copyURL: '',
      phoneTypes: ['通話', '不在着信', '応答なし'],
      phoneImage: [
        'mdi mdi-phone-in-talk mdi-24px',
        'mdi mdi-phone-outgoing mdi-24px',
        'mdi mdi-phone-missed mdi-24px'
      ],
      movieParameter: {
        url: '',
        use: 'youtube',
        file: null,
        id: null,
        filename: ''
      },
      parts: [
        {
          name: '会話',
          status: 0,
          icon: 'mdi mdi-comment',
          character_link: true,
        },
        {
          name: 'タイトル',
          status: 1,
          icon: 'mdi-subtitles-outline',
          character_link: false,
        },
        {
          name: '画像',
          status: 2,
          icon: 'mdi-image',
          character_link: true,
        },
        {
          name: '電話',
          status: 3,
          icon: 'mdi-phone-in-talk',
          character_link: true,
        },
        {
          name: '別の話へ',
          status: 4,
          icon: 'mdi-developer-board',
          character_link: false,
        },
        {
          name: '動画',
          status: 5,
          icon: 'mdi-movie',
          character_link: true,
        },
        {
          name: 'ﾌﾟｯｼｭ通知',
          status: 6,
          icon: 'mdi-email-alert',
          character_link: false,   
        },
        {
          name: 'クイズ',
          status: 7,
          icon: 'mdi-help-circle-outline',
          character_link: false,
        }
      ],
      titleColor: ['black', 'white', 'red', 'orange', 'yellow', 'green', 'skyblue', 'blue', 'purple'],
      titleSize: ['小', '中', '大'],
      userImageFlg: false,
      dialog: '',
      tagModalFlg: false,
      noticeImageOriginal: true,
      noticeImageDefault : true,
      nowScroll: false,
      dragging_pos: {x:0, y:0}
    }
  },
  mounted () {
    if (this.$isClient()) {
      this.$store.dispatch('mediapool/getTagImages', '求人ノベル')
    } else if (this.$isUser()) {
    }
    this.$store.dispatch('mediapool/getStoryOrgImages', this.$route.params.id)
    this.$store.dispatch('chatbot/setStory', this.$route.params.id)
    this.$store.dispatch('chatbot/getScene', this.$route.params.id)
    this.$store.dispatch('chatbot/getCharacter', this.$route.params.id)
  },
  watch: {
    storyDialog: {
      handler () {
        setTimeout(() => {
          for (let i in this.storyDialog) {
            if (this.storyDialog[i].status == 0) this.readColumn('bln', i)
            if (this.storyDialog[i].status == 1) this.readColumn('title', i)
            if (this.storyDialog[i].status == 7) this.readColumn('quiz', i)
          }
          if (this.isMakeDialog) {
            this.isMakeDialog = false
            let target = document.getElementById('textarea-' + 'bln' + Number(this.storyDialog.length - 1))
            if (target) {
              target.focus()
            }
          }
        }, 100)
      },
      deep: true
    },
    scenes: {
      handler () {
        if (this.initDialog) {
          this.$store.dispatch('chatbot/getDialog', this.scenes[this.nowScene].pk)
          this.initDialog = false
        }
      },
      deep: true
    },
    isDelete () {
      console.debug('isDelete')
      console.debug('this.tempScene: ' + this.tempScene)
      this.nowScene = this.tempScene
    },
    nowScene () {
      console.debug('nowScene')
      console.debug('this.nowScene: ' + this.nowScene)
      this.$store.dispatch('chatbot/clearStoryDialog')
      this.$store.dispatch('chatbot/getDialog', this.scenes[this.nowScene].pk)
    },
    characters () {
      if (this.scenes.length != 0) {
        this.$store.dispatch('chatbot/getDialog', this.scenes[this.nowScene].pk)
      }
    },
    // tempFile () {
    //   if (this.tempFile) {
    //     let reader = new FileReader()
    //     reader.onload = (e) => {
    //       let updatedDialog = this.storyDialog[this.idxChangeDialogImage == -1 ? this.idxChangePartsDialog : this.idxChangeDialogImage]
    //       updatedDialog.status = 2
    //       updatedDialog.image_data = e.target.result.replace(/^.*,/, '')
    //       this.$store.dispatch('chatbot/updateDialog', updatedDialog)
    //       this.idxChangeDialogImage = -1
    //       this.idxChangePartsDialog = -1
    //     }
    //     reader.readAsDataURL(this.tempFile)
    //   }
    // },
    tempOriginalIconFile () {
      if (this.tempOriginalIconFile) {
        let reader = new FileReader()
        reader.onload = (e) => {
          let updatedCharacter = this.changeTempCharacter
          updatedCharacter.icon_type = -1
          updatedCharacter.sex_type  = -1
          updatedCharacter.character_icon_data = e.target.result.replace(/^.*,/, '')
          this.$store.dispatch('chatbot/updateCharacter', updatedCharacter)
          this.isChangeCharacterImageModal = false
        }
        reader.readAsDataURL(this.tempOriginalIconFile)
      }
    },
    tempImportFile () {
      let reader = new FileReader()
      reader.readAsText(this.tempImportFile)
      reader.onload = (e) => {
        let textResult = {
          story_id: this.story.story_id,
          import_data: e.target.result,
          scene: this.scenes[this.nowScene].pk
        }
        this.$store.dispatch('chatbot/importStoryView', textResult)
      }
    },
    createDialogFlg () {
      this.saveDialogOrder(this.storyDialog)
    },
    newImage () {
      if(this.isChangeStoryImage){
        this.changeStoryImageOrg(this.newImage.pk)
      } else {
        this.changeSceneImageOrg(this.newImage.pk)
      }
    }
  },
  methods: {
    openSelectModal(type){
      console.log(this.idxChangeDialogImage)
      if (type == 'image'){
        this.$store.dispatch('mediapool/openSelectModal', {type:'image'})
      }
      else if (type == 'video'){
        if (this.movieParameter.use=='youtube') return;
        this.$store.dispatch('mediapool/openSelectModal', {type:'video'})
      }
    },
    selectImage(id){
      if (this.selectModalTarget.type == 'image'){
        let updatedDialog = this.storyDialog[this.idxChangeDialogImage == -1 ? this.idxChangePartsDialog : this.idxChangeDialogImage]
        updatedDialog.status = 2
        updatedDialog.image_id = id
        if (!updatedDialog.character) updatedDialog.character = this.characters[0].pk
        this.$store.dispatch('chatbot/updateDialog', updatedDialog)
        this.idxChangeDialogImage = -1
        this.idxChangePartsDialog = -1
      }
      else if (this.selectModalTarget.type == 'video') {
        this.movieParameter.id = id
        this.movieParameter.filename = this.selectModalTarget.data.name
      }
    },
    loadFile (e) {
      console.debug('*** Start *** loadFile')
      console.debug('e: ' + JSON.stringify(e))
      if (this.uploadedFile) {
        let createFile = new FormData()
        createFile.append('name', this.uploadedFile.name)
        createFile.append('image_data', this.uploadedFile)
        createFile.append('tags', '求人ノベル,')
        this.$store.dispatch('mediapool/saveTagImage', createFile)
        return
      } else if (this.uploadedImage) {
        var file = this.uploadedImage
        var file_name = file.name
        var file_src = undefined
      } else if (this.uploadedMovie) {
        var file = this.uploadedMovie
        var file_name = file.name
        var file_src = undefined
      } else {
        this.dialog = ''
        return
      }
      if (typeof FileReader === "function") {
        console.info('file reader is function')
        const reader = new FileReader();
        this.movieParameter.filename = "Now Loading..."
        reader.onload = event => {
          file_src = event.target.result.replace(/^.*,/, '')
          this.movieParameter.filename = file_name
          if (this.uploadedImage) {
            this.dialog.image_data = file_src
            this.$store.dispatch('chatbot/updateDialog', this.dialog)
            this.uploadedImage = null
            this.dialog = ''
          } else if (this.uploadedMovie) {
            this.movieParameter.file = file_src
            this.uploadedMovie = null
            this.dialog = ''
          }
        };
        reader.onerror = event => {
          this.movieParameter.filename = ""
        };
        reader.readAsDataURL(file);
      } else {
        console.warn('file reader is not function')
        alert('大変申し訳ございません。エラーが発生いたしました。')
      }
      console.debug('*** End *** loadFile')
    },
    copyLink () {
      this.copyURL = process.env.OWN_ENDPOINT + '/cb_share/story/' + this.story.company_id + '/' + this.story.story_id
      this.$nextTick(() => {
        let codeToCopy = document.querySelector('#copy-code')
        codeToCopy.setAttribute('type', 'text')
        codeToCopy.select()
        document.execCommand('copy')
        this.$buefy.snackbar.open({
          message: '求人ノベル表示URLをコピーしました！',
          type: 'is-success',
          position: 'is-top',
          actionText: 'OK',
          indefinite: true
        })
        codeToCopy.setAttribute('type', 'hidden')
        window.getSelection().removeAllRanges()
      })
    },
    scrollDown () {
      var target = document.querySelector('div.balloon-list')
      if (!target) return
      this.$nextTick(() => {target.scrollTop = target.scrollHeight})
    },
    handler (event) {
      event.returnValue = "ページを離れてもよろしいでしょうか？"
    },
    saveBack () {
      this.$store.dispatch('chatbot/clearStory')
      this.isSaveBackModal = false
      if (this.$isClient()) {
        this.$router.push('/dashboard/story')
      } else if (this.$isUser()) {
        this.$router.push('/recruits/story')
      }
    },
    notSaveBack () {
      this.$store.dispatch('chatbot/clearStory')
      this.isSaveBackModal = false
      this.$router.push('/dashboard/story')
    },
    getCharacterName (character) {
      for (let i in this.characters) {
        if (this.characters[i].pk == character) {
          return this.characters[i].name
        }
      }
    },
    getIconCharacter (sexType, iconType, src) {
      if (sexType >= 0) return require('@/assets/character/' + iconType + '_' + (sexType == 0 ? 'female.png' : 'male.png'))
      else return src
    },
    getIconCharacterFromDialog (character) {
      for (let i in this.characters) {
        if (this.characters[i].pk == character) {
          return this.getIconCharacter(this.characters[i].sex_type, this.characters[i].icon_type, this.characters[i].character_icon)
        }
      }
    },
    getBackgroundImage (idx) {
      return require('@/assets/scene/' + idx + '.jpg')
    },
    getBackgroundScene (scene) {
      console.debug('*** Start *** getBackgroundScene')
      if (scene.image_ref) {
        // オリジナル画像があればそれを使う
        for (let img of this.tagImages) {
          if (img.pk == scene.image_ref) {
            return img.image_data
          }
        }
      }
      // デフォルト画像から使う
      return require('@/assets/scene/' + scene.scene_type + '.jpg')
    },
    getBackgroundStory (story) {
      console.debug('*** Start *** getBackgroundStory')
      if (story.icon_ref) {
        for (let img of this.tagImages) {
          if (img.pk == story.icon_ref) {
            return img.image_data
          }
        }
      }
      // デフォルト画像から使う
      return require('@/assets/scene/' + story.icon_type + '.jpg')
    },
    getRandomInt (min, max) {
      return Math.floor( Math.random() * (max + 1 - min) ) + min
    },
    readColumn (type, idx) {
      let target = document.getElementById('textarea-' + type + idx)
      this.$nextTick(()=> {
        target.style.cssText = 'height:auto;'
        target.style.cssText = 'height:' + target.scrollHeight + 'px'
      })
    },
    changeStoryTitle (story) {
      if (story.title == '') {
        alert('タイトルを空欄にはできません')
        story.title = 'no title'
      }
      this.$store.dispatch('chatbot/updateStory', story)
    },
    createScene (order) {
      let createScene = {
        scene_type: 0,
        scene_order: order,
        story: this.story.story_id,
        main_character: null
      }
      this.$store.dispatch('chatbot/createScene', createScene)
    },
    changeSceneImage (i) {
      let updateScene = this.scenes[this.idxChangeSceneImage]
      updateScene.scene_type = i
      updateScene.image_ref = null
      this.$store.dispatch('chatbot/updateScene', updateScene)
      this.idxChangeSceneImage = -1
    },
    changeSceneImageOrg (pk) {
      console.debug('*** Start *** changeSceneImageOrg')
      let updateScene = this.scenes[this.idxChangeSceneImage]
      updateScene.image_ref = pk
      this.$store.dispatch('chatbot/updateScene', updateScene)
      this.$store.dispatch('mediapool/getStoryOrgImages', this.story.story_id)
      this.idxChangeSceneImage = -1
    },
    changeStoryImage (i) {
      let updateStory = this.story
      updateStory.icon_type = i
      updateStory.icon_ref = null
      this.$store.dispatch('chatbot/updateStory', updateStory)
      this.isChangeStoryImage = false
    },
    changeStoryImageOrg (pk) {
      console.debug('*** Start *** changeStoryImageOrg')
      let updateStory = this.story
      updateStory.icon_ref = pk
      this.$store.dispatch('chatbot/updateStory', updateStory)
      this.$store.dispatch('mediapool/getStoryOrgImages', this.story.story_id)
      this.isChangeStoryImage = false
    },
    updateStoryPublic(flg) {
      let updateStory = this.story
      updateStory.is_public = flg
      this.$store.dispatch('chatbot/updateStory', updateStory)
    },
    deleteScene () {
      console.debug('deleteScene')
      this.$store.dispatch('chatbot/deleteScene', this.deleteTempScene.pk)
      // 順番を整える
      var upIdx = 1
      for (let i in this.scenes) {
        if (this.scenes[i].pk != this.deleteTempScene.pk) {
          let updateScene = this.scenes[i]
          updateScene.scene_order = upIdx
          this.$store.dispatch('chatbot/updateScene', updateScene)
          upIdx++
        }
      }
      console.debug('this.nowScene: ' + this.nowScene)
      this.tempScene = this.nowScene
      if (this.tempScene >= this.deleteTempScene.scene_order) {
        if (this.tempScene > 0) {
          this.tempScene--
        }
      }
      console.debug('this.tempScene: ' + this.tempScene)
      this.isDeleteSceneModal = false
    },
    createCharacter () {
      let temp = nameList[this.getRandomInt(0, 459)]
      let createCharacter = {
        name      : temp.name,
        icon_type : this.getRandomInt(1, 9),
        sex_type  : temp.sex,
        story     : this.story.story_id
      }
      this.$store.dispatch('chatbot/createCharacter', createCharacter)
    },
    changeCharacterIcon (sexType, iconType) {
      this.changeTempCharacter.icon_type = iconType
      this.changeTempCharacter.sex_type  = sexType
      this.$store.dispatch('chatbot/updateCharacter', this.changeTempCharacter)
      this.isChangeCharacterImageModal = false
    },
    updateCharacter (c) {
      this.$store.dispatch('chatbot/updateCharacter', c)
    },
    deleteCharacter () {
      this.$store.dispatch('chatbot/deleteCharacter', this.deleteTempCharacter.pk)
      this.isDeleteCharacterModal = false
    },
    createDialog (character) {
      let createDialog = {
        status: 0,
        content: null,
        story: this.story.story_id,
        character: character.pk,
        scene: this.scenes[this.nowScene].pk,
        quiz_choices: ['','']
      }
      this.isMakeDialog = true
      this.$store.dispatch('chatbot/createDialog', createDialog)
      setTimeout(() => {this.scrollDown()}, 200)
    },
    changeCharacterDialog () {
      let updateDialog = this.changeTempCharacterDialog
      if (this.selectedCharacter) {
        updateDialog.character = this.selectedCharacter.pk
      } else {
        updateDialog.character = null
      }
      this.$store.dispatch('chatbot/updateDialog', updateDialog)
      this.isChangeCharacterDialogModal = false
    },
    changeCharacterTempDialog () {
      if (this.selectedCharacter) {
        this.tempDialog.character = this.selectedCharacter.pk
      } else {
        this.tempDialog.character = null
      }
      this.isChangeCharacterTempDialogModal = false
    },
    changeParts (dialog, p) {
      if (p.character_link && this.characters.length == 0) {
        alert('登場人物を追加してください')
        return
      }
      if (!dialog.quiz_choices && p.status === 7) {
        // クイズパーツに変更で選択肢がない場合は初期値追加
        this.$set(dialog, 'quiz_choices', ['',''])
      }
      // 画像はモーダルを開く
      if (p.status == 2) {
        this.openSelectModal('image')
        return
      }
      let updateDialog = dialog
      updateDialog.status = p.status
      // キャラクター紐付けを適切に設定
      if (!updateDialog.character && p.character_link) {
        updateDialog.character = this.characters[0].pk
      }
      if (updateDialog.character && !p.character_link) {
        updateDialog.character = null
      }
      this.$store.dispatch('chatbot/updateDialog', updateDialog)
      this.idxChangePartsDialog = -1
    },
    changeTempParts (p) {
      if (p.character_link && this.characters.length == 0) {
        alert('登場人物を追加してください')
        return
      }
      this.tempDialog.status = p.status
      if (!p.character_link && this.tempDialog.character) {
        this.tempDialog.character = null
      }
      if (p.character_link && !this.tempDialog.character) {
        this.tempDialog.character = this.characters[0].pk
      }
      this.createInsertDialog()
    },
    saveDialogOrder (dialogs) {
      let dlg = dialogs
      for (let d in dlg) {
        dlg[d].dialog_order = Number(d) + 1
        this.$store.dispatch('chatbot/updateDialog', dlg[d])
      }
    },
    saveSceneOrder (scenes) {
      let sns = scenes
      for (let s in scenes) {
        sns[s].scene_order = Number(s) + 1
        this.$store.dispatch('chatbot/updateScene', sns[s])
      }
    },
    createTempDialog (idx) {
      this.idxCreateDialog = idx
      this.tempDialog = {
        status: 0,
        content: null,
        dialog_order: this.idxCreateDialog + 1,
        phone_type: 0,
        quiz_choices: ['',''],
        story: this.story.story_id,
        character: null,
        scene: this.scenes[this.nowScene].pk
      }
    },
    createInsertDialog () {
      this.$store.dispatch('chatbot/createIDXDialog', this.tempDialog)
      this.idxCreateDialog = -2
    },
    registerMovie (d) {
      console.debug('***** Start ***** registerMovie')
      if (this.movieParameter.use == 'youtube' && this.movieParameter.url != '') {
        d.movie_url = this.movieParameter.url
        this.$store.dispatch('chatbot/updateDialog', d)
        this.movieParameter.url =  ''
        this.movieParameter.use =  'youtube'
        this.movieParameter.file =  null
      }
      if (this.movieParameter.use == 'movie_file') {
        d.movie_url = null
        if (this.$isUser() && this.movieParameter.file){
          d.movie_data = this.movieParameter.file
        }
        else if (this.$isClient() && this.movieParameter.id){
          d.movie_id = this.movieParameter.id
        }
        this.$store.dispatch('chatbot/updateDialog', d)
        this.movieParameter.url =  ''
        this.movieParameter.use =  'movie_file'
      }
      this.idxChangeDialogImage = -1
      this.idxChangePartsDialog = -1
      console.debug('***** End ***** registerMovie')
    },
    clickColorBtn (d, c) {
      d.title_color = c
      this.$store.dispatch('chatbot/updateDialog', d)
    },
    clickBgColorBtn (d, c) {
      d.title_bg_color = c
      this.$store.dispatch('chatbot/updateDialog', d)
    },
    clickSizeBtn (d, s) {
      d.title_size = s
      this.$store.dispatch('chatbot/updateDialog', d)
    },
    clickChoiceBtn (d, p) {
      if (!d.quiz_choices) d.quiz_choices = ['']
      else if (p == 'plus') d.quiz_choices.push('')
      else if (p == 'minus') d.quiz_choices.pop()
      this.$store.dispatch('chatbot/updateDialog', d)
    },
    getIconNews (src) {
      return require('@/assets/news/news' + src + '.png')
    },
    openTagModal () {
      this.tagModalFlg = true
    },
    tagCandidate (st, t) {
      var tagBox = []
      if (!this.story.tags) {
        let updateData = st
        updateData.tags = t + ','
        this.$store.dispatch('chatbot/updateStory', updateData)
      } else {
        tagBox.push(this.story.tags.split(","))
        if (tagBox[0].indexOf(t) == -1) {
          let updateData = st
          if (updateData.tags) updateData.tags += t + ','
          else updateData.tags = t + ','
          this.$store.dispatch('chatbot/updateStory', updateData)
          this.$refs.refinput.tagBlank()
        }
      }
    },
    deleteTags(st, i){
      var tagBox=[]
      var tagText=""
      tagBox.push(this.story.tags.split(","))
      tagBox[0].splice(i, 1)
      tagText = tagBox[0].join(",")
      let updateData = st
      updateData.tags = tagText
      this.$store.dispatch('chatbot/updateStory', updateData)
    },
    onScrollImg (img){
      this.nowScroll = true
      if (img == 'original') {
        this.noticeImageOriginal = false
      } else {
        this.noticeImageDefault = false
      }
    },
    dropCharacter(c) {
      const rect = this.$refs.storyArea.getBoundingClientRect()
      const pos_top = rect.top + window.pageYOffset
      const pos_bottom = rect.bottom + window.pageYOffset
      const pos_left = rect.left + window.pageXOffset
      const pos_right = rect.right + window.pageXOffset

      if (this.dragging_pos.x > pos_left && this.dragging_pos.x < pos_right
      && this.dragging_pos.y > pos_top && this.dragging_pos.y < pos_bottom) {
        this.createDialog(c);
      }
    },
    draggingCharacter(e) {
      if (e.x==0 && e.y==0) return
      this.dragging_pos.x = e.x
      this.dragging_pos.y = e.y
    }
  }
}
</script>

<style lang="scss" scoped>
.container-story {
  height: 100vh;
  width: 100%;
  overflow-x: hidden;
  //overflow-y: scroll;
  position: relative;
}
.container-story::-webkit-scrollbar {
  //width: 10px;
  //height: 10px;
  //visibility: hidden;
}
.header-box {
  width: calc(100% - 80px);
  margin: 10px 40px;
  margin-bottom: 25px;
  padding: 15px 10px;
  display: flex;
  justify-content: space-between;
  border-bottom: dotted 6px #323;
}
.header-menu {
  display: flex;
  justify-content: center;
  align-items: center;
}
.main-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  height: calc(100% - 138px);
  width: calc(100% - 64px);
  max-width: 1000px;
  margin: 0 auto;
  position: relative;
}
.loading-container {
  height: 100%;
  width: 100%;
  position: absolute;
  background: rgba(255, 255, 255, 0.7);
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.header-main {
  width: 100%;
  height: 60px;
  background: #eee;
  display: flex;
  justify-content: space-between;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  margin-bottom : 8px;
}
.header-main > p {
  width: calc(100% - 162px);
  display: flex;
  justify-content: center;
  font-size: smaller;
}
.header-main > p > span {
  width: calc(100% - 136px);
}
.header-main > p > span > input {
  width: 100%;
  background: white !important;
  border: none;
  border-radius: 0;
}
.header-main > p > span > p{
  font-size: 12px;
  color: #666;
  text-align: left;
  padding-top: 3px;
}
.noborder-button {
  border: none;
  border-radius: 0;
}
.menu-box {
  width: calc(40% - 4px);
  height: calc(100% - 58px);
  background: #FEFEFE;
  padding: 16px;
  text-align: left;
}
.edit-box {
  width: calc(60% - 4px);
  height: calc(100% - 58px);
  background: #f2e2f2;
  padding: 16px;
  text-align: left;
}
.menu-edit {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.header-recruit {
  width: 100%;
  height: 120px;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  position: relative;
  color: white;
  background: transparent;
}
.header-recruit > img {
  width: 100%;
  height: 120px;
  max-height: auto;
  object-fit: cover;
  position: absolute;
  z-index: 0;
  filter: brightness(60%) blur(0.5px);
}
.init-title {
  width: 100%;
  height: 60px;
  padding-left: 8px;
  padding-right: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: transparent;
  z-index: 1;
}
.title-box {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  padding-left: 16px;
  font-size: larger;
  font-weight: 600;
  background: transparent;
  z-index: 1;
}
.character-container {
  height: calc(100% - 43px);
  width: 100%;
  margin-top: 8px;
  padding: 16px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.img-box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  flex-wrap: wrap;
}
.character-icon {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 50%;
  background: #eee;
  margin-right: 8px;
  cursor: pointer;
}
.chara-plus-button {
  font-weight: 600; display: flex; justify-content: center; align-items: center;
}
.scene-container {
  height: calc(100% - 43px);
  width: 100%;
  margin-top: 8px;
  padding: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
}
.scene-container > img {
  height: 100%;
  width: calc(100% - 16px);
  object-fit: cover;
  position: absolute;
  top: 8px;
  filter: brightness(60%) blur(2px);
}
.balloon-list {
  height: 100%;
  width: 100%;
  margin-top: 8px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  position: relative;
}
.dialog-box {
  position: relative;
  padding-top: 8px;
}
.dialog-box > button {
  color: white;
}
.dialog-box > .left-button {
  left: 8px;
}
.bln-box {
  display: flex;
  width: 100%;
  &.-title {
    display: block;
    margin-bottom: 16px;
  }
}
.bln-box:hover {
  background: rgba(200, 200, 200, 0.3);
}
.bln-box > img {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 50%;
  background: #eee;
  margin-right: 8px;
}
.message-box, .message-box-title, .next-box {
  margin-bottom: 16px;
  min-height: 80px;
}
.message-box {
  width: calc(100% - 54px);
}
.message-box-title {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 0;
  .font-small {
    font-size: 16px;
  }
  .font-medium {
    font-size: 20px;
  }
  .font-large {
    font-size: 24px;
    font-weight: bold;
  }
}
.next-box {
  position: relative;
  width: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .select-box {
    position: relative;
    width: 100%;
  }
}
.message-box > img {
  max-width: calc(100% - 64px);
}
.message-box > p {
  color: #f8f8f8;
  font-size: smaller;
}
.message-box > textarea {
  display: block;
  width: 80%;
  resize: none;
  font-size: smaller;
  height: auto;
  padding: 8px;
  border-radius: 8px;
  border: none;
}
.message-box-title > textarea {
  display: block;
  width: 80%;
  resize: none;
  font-size: medium;
  height: auto;
  padding: 8px;
  border: none;
  text-align: center;
  background: rgb(252, 252, 252);
}
.message-box > .no-image {
  border-radius: 4px;
  background: #222222cc;
  color: #fefefe;
  width: calc(100% - 64px);
  height: 96px;
  padding: 8px;
  display: flex; justify-content: center; align-items: center;
}
.message-box > .upload-button {
  text-align: left;
}
.no-character {
  justify-content: center;
}
.no-character > .message-box > img {
  display: block;
  margin: 0 auto;
}
.no-character > .message-box > .upload-button {
  text-align: left;
}
.my-speaker {
  justify-content: end;
  flex-direction: row-reverse;
}
.my-speaker > .message-box {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-end;
  margin-right: 8px;
}
.my-speaker > .message-box > p {
  text-align: end;
  margin-right: 8px;
}
.my-speaker > .message-box > textarea {
  background: #ADDB67 !important;
  color: #222 !important;
  float: right;
  margin-right: 8px;
}
.my-speaker > .message-box > .no-image {
  border-radius: 4px;
  background: #222222cc;
  color: #fefefe;
  width: calc(100% - 64px);
  height: 96px;
  padding: 8px;
  display: flex; justify-content: center; align-items: center;
}
.parts-box {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  background: rgba(222, 232, 222, 0.8);
  margin-bottom: 8px;
  padding: 8px;
  border-radius: 4px;
}
.parts-box > .parts {
  width:  54px;
  height: 54px;
  margin: 4px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #eef;
  font-size: xx-small;
  cursor: pointer;
}
.parts-box > .parts > div {
  width:  54px;
  height: 54px;
  margin: 4px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #eef;
  font-size: xx-small;
  cursor: pointer;
}
.parts-box > .parts > div > label {
  width:  54px;
  height: 54px;
  margin: 4px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #eef;
  font-size: xx-small;
  cursor: pointer;
}
.phone-box {
  width:  54px;
  height: 54px;
  margin: 4px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #eef;
  font-size: xx-small;
  cursor: pointer;
}
.character-box {
  width: 100px;
  height: 100px;
  margin: 8px;
  background: #fee;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
}
.character-box > input {
  width: 80%;
  border: none;
  background: #FEFEFE;
  border-radius: 0;
  margin-top: 4px;
}
.close-button {
  width: 36px;
  height: 36px;
  position: absolute;
  right: 0;
  top: 0;
  background: transparent;
  border: none;
  padding: 0;
}
.chat-button {
  width: 36px;
  height: 36px;
  position: absolute;
  left: 0;
  top: 0;
  background: transparent;
  border: none;
  padding: 0;
}
.drag-button {
  width: 36px;
  height: 36px;
  position: absolute;
  right: 0;
  top: 36px;
  background: transparent;
  border: none;
  padding: 0;
}
.app-button {
  width: 36px;
  height: 36px;
  position: absolute;
  right: 0;
  top: 72px;
  background: transparent;
  border: none;
  padding: 0;
}
.button-story {
  background: rgba(0, 0, 0, 0.7);
  color: #f8f8f8;
  border-radius: 16px;
}
.scene-list {
  position: absolute;
  right: 0;
  min-width: 300px;
  width: 50%;
  background: #f0f0f0;
  height: 100%;
  z-index: 10;
  padding: 16px;
}
.scene-list-modal {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9;
}
.scene-list > p {
  margin-bottom: 8px;
  font-weight: 600;
}
.scene-list > button {
  margin-top: 8px;
  width: 100%;
}
.scene-box {
  width: 100%;
  height: auto;
  position: relative;
  margin-top: 8px;
}
.scene-box > img {
  width: 100%;
  height: 80px;
  max-height: auto;
  object-fit: cover;
  filter: brightness(50%) blur(1px);
}
.scene-inner {
  position: absolute;
  left: 0; top: 0;
  width: 100%;
  height: 80px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
}
.scene-inner > p {
  font-size: larger;
  font-weight: 600;
  width: calc(100% - 264px);
  height: 100%;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.scene-inner > .set {
  font-size: medium;
  font-weight: 600;
  margin-right: 8px;
  height: calc(100% - 8px);
  width: 80px;
  background: transparent;
  color: white;
  border: solid thin #aae;
}
.scene-inner > .change {
  font-size: medium;
  font-weight: 600;
  margin-right: 8px;
  height: calc(100% - 8px);
  width: 80px;
  background: transparent;
  color: white;
  border: solid thin #aea;
}
.scene-inner > .del {
  font-size: medium;
  font-weight: 600;
  margin-right: 8px;
  height: calc(100% - 8px);
  width: 80px;
  background: transparent;
  color: white;
  border: solid thin #eaa;
}
.scene-inner > .drag {
  font-size: medium;
  font-weight: 600;
  margin-left: 8px;
  height: calc(100% - 8px);
  width: 80px;
  background: transparent;
  color: white;
}
.change-image-box {
  height: auto;
  width: 100%;
  position: relative;
  margin-top: 16px;
}
.change-image-box > button {
  float: right;
  background: transparent;
  border: none;
  padding: 0;
}
.change-image-galary {
  display: flex;
  height: auto;
  width: 100%;
  //overflow-x: scroll;
  //overflow-y: hidden;
}
.change-image-galary.absolute{
  position: absolute;
  z-index:3;
}
.change-image-galary::-webkit-scrollbar {
  //width:  10px;
  //height: 10px;
  //visibility: hidden;
}
.change-image-galary > img {
  height: 200px;
  width: 33%;
  object-fit: cover;
  margin-right: 16px;
  filter: brightness(80%) blur(1px);
  cursor: pointer;
}
.setting-box {
  width: 100%; display: flex; padding: 8px;
  flex-wrap: wrap;
}
.setting-box-left {
  width: calc(70% - 8px);
  display: flex; justify-content: flex-start; align-items: center;
  flex-direction: column;
  margin-right: 8px;
}
.setting-box-right {
  width: 30%;
  justify-content: center; align-items: center; display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}
.setting-box-left > p {
  width: 100%;
  text-align: left;
  font-size: smaller;
}
.setting-box-right > p {
  width: 100%;
  text-align: left;
  font-size: smaller;
}
.dot-line {
  height: 10px;
  width: 100%;
  background-image: url('../../../assets/lp/dot.png');
  background-repeat: repeat-x;
  background-size: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
}
.right-enter-active, .right-leave-active {
  transform: translate(0px, 0px);
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.right-enter, .right-leave-to {
  transform: translateX(100vw) translateX(0px);
}
.bottom-enter-active, .bottom-leave-active {
  transition: all 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  transform: scaleY(1);
  transition-timing-function: ease-in-out;
  transition-delay: 100ms;
}
.bottom-enter, .bottom-leave-to {
  transform: scaleY(0);
}
/* temp用のCSS */
.temp-add-box {
  width: 100%; margin-top: 4px; margin-bottom: 4px;
  button {
    background: rgba(255, 255, 255, 0.2); color: #f8f8f8; border-radius: 0;
  }
}
.temp-add-openbox {
  background: rgba(255, 255, 255, 0.2); width: 100%; margin-top: 4px; margin-bottom: 4px;
  .preview-box {
    display: flex; justify-content: center; padding: 8px; width: 100%;
    .temp-img-box {
      margin-right: 8px;
      img, div {
        cursor: pointer;
        width: 48px; height: 48px; border-radius: 50%; background: #FEFEFE; object-fit: cover;
        display: flex; justify-content: center; align-items: center;
      }
      p {
        color: #f8f8f8; font-size: smaller; text-align: center; margin-top: 2px;
        max-width: 48px;
      }
    }
    .temp-edit-box {
      width: calc(100% - 54px);
      textarea {
        display: block;
        width: 100%;
        resize: none;
        font-size: smaller;
        height: auto;
        padding: 8px;
        border-radius: 8px;
        border: none;
      }
      .temp-no-image {
        border-radius: 4px;
        background: #222222cc;
        color: #fefefe;
        width: calc(100% - 4px);
        height: 96px;
        padding: 8px;
        display: flex; justify-content: center; align-items: center;
      }
    }
  }
}
.no-movie {
  border-radius: 4px;
  background: #222222cc;
  color: #fefefe;
  width: calc(100% - 64px);
  margin-top: 8px;
  padding: 8px;
}
.no-movie-item {
  font-size: 12px;
  margin-bottom: 4px;
}
.movie-container {
  display: contents;
  margin-bottom: 8px;
  .no-image {
    border-radius: 4px;
    background: #222222cc;
    color: #fefefe;
    width: calc(100% - 64px);
    height: 96px;
    padding: 8px;
    display: flex; justify-content: center; align-items: center;
  }
}
.title-edit-container {
  display: flex;
  justify-content: center;
}
.title-edit-wrapper {
  border-radius: 4px;
  background: #222222cc;
  color: #fefefe;
  width: 80%;
  margin-top: 8px;
  padding: 8px;
}
.color-btn-container {
  p {
    font-size: 12px;
  }
}
.color-btn-wrapper {
  display: flex;
  justify-content: space-evenly;
  margin-top: 4px;
  background: lightgray;
  height: 24px;
  align-items: center;
}
.color-btn {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.margin-top8 {
  margin-top: 8px;
}
.size-btn-wrapper {
  display: flex;
  justify-content: space-around;
  margin-top: 4px;
  button {
    width: 80px;
  }
}
$title-color: (
  'black': black,
  'white': white,
  'red': red,
  'orange': orange,
  'yellow': yellow,
  'green': green,
  'skyblue': skyblue,
  'blue': blue,
  'purple': purple,
);
@each $colorName, $color in $title-color {
  .font-color-#{$colorName} {
    color: $color;
  }
  .bg-color-#{$colorName} {
    background-color: $color !important;
  }
}
.news-edit-container {
  display: flex;
  justify-content: center;
}
.news-item{
  font-size:12px;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  border-radius: 4px;
  background: #222222cc;
  color: #fefefe;
  width: 80%;
  margin-top: 8px;
  padding: 10px;
}
.news-edit-wrapper {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  color: #fefefe;
  padding:10px 5px 0;
  
}
.news-edit-wrapper img{
  height:45px;
  margin:0 5px;
}
.news-container {
  background-color: white;
  display: grid;
  grid-template-columns: 20% 80%;
  grid-template-rows: 70px 80px;
  grid-template-areas: "news-img news-title" "news-text news-text";
  height:150px;
  width: 80%;
  margin:0 auto;
}
.news-img {
  grid-area: news-img;
  padding:10px 10px 10px 20px;
}
.news-img img{
  height: 100%;
  border:solid black 1px;
  border-radius: 10px; 
}
.news-text {
  grid-area: news-text;
}
.news-title {
  grid-area: news-title;
}
.news-text{
  border: none;
  resize:none;
  margin:0 10px 10px;
  padding: 0.5em;          /* 内側の余白量 */
  width: calc(100% - 20px);             /* 横幅 */
  font-size: 1em;          /* 文字サイズ */
  line-height: 1.2;        /* 行の高さ */
  background-color:white;
}
.scroll-parent{
  position:relative;
  height:216px;
  z-index:2;
  margin-top: 8px;
}
.news-title{
  border: none;
  resize:none;
  padding: 0.5em;          /* 内側の余白量 */
  width: calc(100% - 10px);            /* 横幅 */
  font-size: 1em;          /* 文字サイズ */
  line-height: 1.2;        /* 行の高さ */
  background-color:white;
}
.quiz-question {
  width: 100% !important;
}
.quiz-choices {
  display: flex;
  margin-top: 3px;
  height: 25px;
  p {
    color: #f8f8f8;
    font-size: smaller;
    width: 65px;
    margin-left: 15px;
  }
  input {
    width: calc(100% - 90px);
  }
}
.quiz-add-choice {
  margin-left: 80px;
  margin-top: 3px;
  button {
    background: rgba(255, 255, 255, 0.2);
    color: #f8f8f8;
    border-radius: 0;
    height: 25px;
  }
}
// タグ
.plus-button {
  background: rgba(255, 255, 255, 0.0);
  cursor: pointer;
  color: white;
  border: none;
  outline : none;
}
.edit-taginput {
  background: rgba(255,255,255, 0.00) !important;
  width: 80px;
  text-align: center;
  color: white;
  border: none;
  font-size: 12px;
  option {
    color: #000;
  }
}
.edit-taginput::placeholder {
  color: white;
  font-size: 12px;
}
.scroll-box {
  font-size:10px;
  color: white;
  background-color: rgba(0, 0, 0, 0.7);
  position: absolute;
  z-index: 3;
  width: 120px;
  height: 90px;
  top: calc(50% - 45px);
  left: calc(50% - 60px);
}
.loading-cover {
  color: white;
  background-color: rgba(0, 0, 0, 0.7);
  position: absolute;
  z-index: 3;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.move{
  animation: shake .60s linear infinite alternate;
}
.add-btn-explaination {
  margin-left: 16px;
  margin-right: 4px;
  text-align: left;
  color: #666;
  font-size:xx-small;
  text-align: center;
  .str {
    font-weight: bold;
  }
}
@keyframes shake {
  100% {
    transform: translateX(5%);
  }
}
</style>


// WEBPACK FOOTER //
// src/views/DashBoard/Story/StoryEdit.vue